import ParallaxSection from "./ParallaxSection"
import Header from "./Header"
import Services from "./Services"
import Testimonials from "./Testimonials"
import AboutPage from "./About"
import Projects from "./Projects"
import Contact from "./Contact"
import CookieConsent from "./CookiesConsent"
import TeamBoard from "./TeamBoard"
// import Team from "./Team"
// import ClientsSection from "./Clients"
function Home() {
  return (
    <div>
      
      <ParallaxSection />
      <AboutPage/>
      <Services/>
      <Projects/>
      {/* <TeamBoard/> */}
      <Testimonials/>
      <Contact/>
      <CookieConsent/>
      {/* <Header />
      <Services/>
      <Testimonials/> */}
      {/* <Team/>
      <ClientsSection/> */}

    </div>
  )
}

export default Home
